import React from 'react';

import { ComponentProps } from '../../typings/generic-component';
import { IClassNames, makeClassNames } from '../../utils/styles';
import './post-image.scss';

export interface IPostImage extends ComponentProps {
  imgSrc: string;
  imgCredits?: string | null;
  imgCaption?: string | null;
  imgAlt?: string | null;
}

const classNames = (): IClassNames =>
  makeClassNames({
    PostImage: 'post-image-v2',
    PostImageCredits: 'post-image__credits-v2',
    PostImageCaption: 'post-image__caption-v2',
  });

const PostImage: React.FC<IPostImage> = ({ imgSrc, imgCredits = '', imgCaption, imgAlt }) => {
  const cn = classNames();

  return (
    <div className={cn.PostImage}>
      <figure>
          <img src={imgSrc} alt={imgAlt || undefined} title={imgCaption || undefined} loading="lazy" />
          {(imgCredits || imgCaption) && (
            <figcaption>
              <p className={cn.PostImageCredits} dangerouslySetInnerHTML={{ __html: imgCredits || '' }} />
              <p className={cn.PostImageCaption}>{imgCaption}</p>
            </figcaption>
          )}
        </figure>
    </div>
  );
};

export default PostImage;
